"use strict";

import { ResourcesList } from "generated";

var SoundService = {};

const soundsExtensions = [".mp3", ".ogg", ".wav"];
const soundsArr = Object.values(ResourcesList.resourcesList).filter((x) =>
    soundsExtensions.some((ext) => x.toLowerCase().endsWith(ext))
);

const sounds = soundsArr.reduce((acc, cur) => {
    try {
        const audioFileName = cur.toLocaleLowerCase();
        acc[audioFileName] = new Audio(`resources/${cur}`); // Сначала надо загрузить все аудиофайлы, перед тем, как начать их воспроизводить,
        // поскольку в неактивных вкладках браузера загрузка файлов может не работать и соответственно аудио воспроизводиться не будет
        acc[audioFileName].setAttribute("filename", cur);
        acc[audioFileName].onended = () => SoundService.onAudioEnded();
    } catch (e) {
        console.log(`can not load file: ${e}`);
    }
    return acc;
}, {});

const invalid_sounds = {};

var play_queue = [];
var isPlayingSomething = false;

SoundService.call = function (param) {
    if (!param.Sound) {
        return;
    }

    const sound_index = SoundService.findInQueue(param.soundId);
    if (sound_index != null) {
        play_queue[sound_index].repeat = param.Rep;
        play_queue[sound_index].priority = param.Priority;
        return;
    } else {
        if (param.Play) {
            const audioFileName = param.Sound.toLocaleLowerCase();
            if (window.ipc) {
                if (_globalParams.PlayAudioFromMainMonitorOnly) {
                    if (!window.$sw.isMainWindow) {
                        return;
                    }
                } else {
                    const enablePlay = window.ipc.get().sendSync("server", "requestPlay", param.soundId);
                    if (!enablePlay) {
                        return;
                    }
                }
            }

            const sound = sounds[audioFileName];
            if (!sound) {
                if (!invalid_sounds[audioFileName]) {
                    invalid_sounds[audioFileName] = true;
                    $ns.add({
                        type: "warning",
                        time: new Date().toLocaleString(),
                        title: String.format(i18next.t("sound_not_found"), audioFileName),
                    });
                }
                return;
            }

            play_queue.push({
                sound,
                repeat: param.Rep,
                priority: param.Priority,
                soundId: param.soundId,
            });
            if (!isPlayingSomething) {
                isPlayingSomething = true;
                const playPromise = sound.play();
                if (playPromise !== undefined) {
                    playPromise
                        .then((_) => { })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
        }
    }
};
SoundService.stop = function (param) {
    if (param.Stop && isPlayingSomething) {
        const sound_index = SoundService.findInQueue(param.soundId);
        if (sound_index != null) {
            isPlayingSomething = false;
            const audioFileName = param.Sound.toLocaleLowerCase();
            const sound = sounds[audioFileName];
            sound.pause();
            sound.currentTime = 0;
            play_queue.splice(sound_index, 1);
            if (window.ipc && !_globalParams.PlayAudioFromMainMonitorOnly) {
                window.ipc.get().send("server", "stopPlay", param.soundId);
            }
        }
    }

    if (!isPlayingSomething && play_queue.length > 0) {
        play_queue[0].sound.play();
        isPlayingSomething = true;
    }
};

SoundService.onAudioEnded = function() {
    if (window.ipc && !_globalParams.PlayAudioFromMainMonitorOnly && !play_queue[0].repeat) {
        window.ipc.get().send("server", "stopPlay", play_queue[0].soundId);
    }
    if (play_queue[0].repeat) {
        play_queue.push(play_queue[0]);
    }
    play_queue.shift();
    if (play_queue.length > 0) {
        play_queue[0].sound.play();
    } else {
        isPlayingSomething = false;
    }
};

SoundService.findInQueue = function (id) {
    for (var i = 0; i < play_queue.length; i++) {
        if (play_queue[i].soundId === id) {
            return i;
        }
    }
    return null;
};

export { SoundService };
